const CHUNK_RELOAD_KEY = 'food_chunk_reload'

export function isChunkLoadError(error) {
  const message = String(error?.message || error || '')
  return /Loading chunk|Failed to fetch dynamically imported module|Importing a module script failed|error loading dynamically imported module/i.test(
    message,
  )
}

export function clearChunkReloadFlag() {
  if (typeof sessionStorage !== 'undefined') {
    sessionStorage.removeItem(CHUNK_RELOAD_KEY)
  }
}

export function handleChunkLoadError(error, onFallback) {
  if (!isChunkLoadError(error) || typeof window === 'undefined') {
    return false
  }

  if (navigator.onLine !== false && typeof sessionStorage !== 'undefined') {
    if (!sessionStorage.getItem(CHUNK_RELOAD_KEY)) {
      sessionStorage.setItem(CHUNK_RELOAD_KEY, '1')
      window.location.reload()
      return true
    }
  }

  onFallback?.()
  return true
}

if (typeof window !== 'undefined') {
  window.addEventListener('online', clearChunkReloadFlag)
}
